import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["items", "notFoundLabel", "loading", "multiple", "renderListAsMotion", "getItemAttributes", "getItemDisabled", "getItemLeftSide", "getItemKey", "getItemOnClick", "getItemRef", "getItemDescription", "getItemLabel", "getItemChecked"];
import React, { forwardRef, useCallback } from 'react';
import { cnBem } from '@carnica/utils';
import { Text } from "../Text";
import { List } from "../../modules/List";
import { Checkbox } from "../Checkbox";
import styles from "./styles.pcss";
import { composePreparedProps } from "./utils";
import { ActionSheetWrapper } from "./ActionSheetWrapper";
var cnActionSheet = cnBem('action-sheet', styles);
var ActionSheetRender = function ActionSheetRender(props, ref) {
  var _composePreparedProps = composePreparedProps(props),
    items = _composePreparedProps.items,
    _composePreparedProps2 = _composePreparedProps.notFoundLabel,
    notFoundLabel = _composePreparedProps2 === void 0 ? 'Ничего не найдено 😔' : _composePreparedProps2,
    loading = _composePreparedProps.loading,
    multiple = _composePreparedProps.multiple,
    renderListAsMotion = _composePreparedProps.renderListAsMotion,
    getItemAttributes = _composePreparedProps.getItemAttributes,
    getItemDisabled = _composePreparedProps.getItemDisabled,
    getItemLeftSide = _composePreparedProps.getItemLeftSide,
    getItemKey = _composePreparedProps.getItemKey,
    getItemOnClick = _composePreparedProps.getItemOnClick,
    getItemRef = _composePreparedProps.getItemRef,
    getItemDescription = _composePreparedProps.getItemDescription,
    getItemLabel = _composePreparedProps.getItemLabel,
    getItemChecked = _composePreparedProps.getItemChecked,
    otherProps = _objectWithoutProperties(_composePreparedProps, _excluded);
  var getItemRightSide = useCallback(function (item) {
    if (!multiple) {
      return null;
    }
    return /*#__PURE__*/React.createElement(Checkbox, {
      checked: getItemChecked(item),
      disabled: getItemDisabled(item),
      tabIndex: -1,
      "data-t-id": "components-ActionSheet"
    });
  }, [multiple, getItemChecked, getItemDisabled]);
  if (loading || !(items !== null && items !== void 0 && items.length)) {
    return /*#__PURE__*/React.createElement(ActionSheetWrapper, _extends({
      loading: loading,
      ref: ref
    }, otherProps), !loading && /*#__PURE__*/React.createElement(Text, {
      align: "center",
      className: cnActionSheet('not-found'),
      color: "secondary-fake-invert",
      variant: "body-small"
    }, notFoundLabel));
  }
  return /*#__PURE__*/React.createElement(ActionSheetWrapper, _extends({
    hasItems: true,
    ref: ref
  }, otherProps), /*#__PURE__*/React.createElement(List, {
    getItemAttributes: getItemAttributes,
    getItemChecked: getItemChecked,
    getItemDescription: getItemDescription,
    getItemDisabled: getItemDisabled,
    getItemKey: getItemKey,
    getItemLabel: getItemLabel,
    getItemLeftSide: getItemLeftSide,
    getItemOnClick: getItemOnClick,
    getItemRef: getItemRef,
    getItemRightSide: getItemRightSide,
    invert: true,
    items: items,
    motion: renderListAsMotion,
    "data-t-id": "components-ActionSheet"
  }));
};
export var ActionSheet = /*#__PURE__*/forwardRef(ActionSheetRender);